import React from 'react'
import EditPageTop from './editPageTop'
import EditPageLeft from './editPageLeft'
import './editPage.css'
import FileSearch from './fileComponet/fileSearch'
import ArticleAPP from './article/articleApp'
import MoudleFrame from './MoudleWork/ModuleFrame'
import Moban from './MoudleWork/Moban'
import TextPreview from './filePreview/textPreview'
import Consult_App from './consultComponent/consultAPP'
import Editor_Pad from './editorPad'
import Set_APP from './settingPage/settingAPP'
import {fetchGet, fetchPost} from "./utils/fetchData";
import {convert_FormData_to_json2} from "../config";
import {message} from "antd/lib/index";
import {Modal,Button} from 'antd'
import {showErrorMsg} from "./utils/commonFunc";
import SectionAPP from './SectionWaterFall/sectionAnalyse'
import Detection from './SectionWaterFall/detection'


class EditPad extends React.Component {
    constructor(props) {
        super(props);
        this.isOpenFileEidt = false;
        this.fileName='';
        this.suggestWord = '';    //todo
        this.state = {
            filerSearchVisible:false,
            previewPageVisible:false,
            fileContent:null,
            fileName:null,
            fileId:null,
            consult_visible:false,
            isEditPreviewContent:false,
            settingPageVisible:false,
            modalVisible:false,
            articlePadVisible:false,
            moudleFrameVisible:false,
            mobanVisible:false,
            suggestionSentence:[],
            fenci:[],
        }
    }

    // componentDidMount(){
        // let self = this;
        //
        // //方法调用
        //
        // this._onBlurHandler(self)
        // document.onclick=this.dismissFileSearch;
        // const listener = ev => {
        //     ev.preventDefault();
        //     ev.returnValue='文章要保存吼，确定离开吗？';
        // };
        // window.addEventListener('beforeunload', listener);
        // return () => {
        //     window.removeEventListener('beforeunload', listener)
        // }
    // };

    componentWillMount () {
        // 拦截判断是否离开当前页面
        window.addEventListener('beforeunload', this.beforeunload);
    }
    componentWillUnmount () {
        // 销毁拦截判断是否离开当前页面
        window.removeEventListener('beforeunload', this.beforeunload);
    }
    beforeunload = (e) => {
        let confirmationMessage = '你确定离开此页面吗?';
        (e || window.event).returnValue = confirmationMessage;
        return confirmationMessage;
    }

    dismissFileSearch = () => {
        this.setState({
           filerSearchVisible:false,
        });
    };

    dismissArticle = () => {
        this.setState({
            articlePadVisible:false,
        });
    };

    // _onBlurHandler(self){
    //     document.body.addEventListener('click', function(e){
    //         //针对不同浏览器的解决方案
    //         function matchesSelector(element, selector){
    //             if(element.matches){
    //                 return element.matches(selector);
    //             } else if(element.matchesSelector){
    //                 return element.matchesSelector(selector);
    //             } else if(element.webkitMatchesSelector){
    //                 return element.webkitMatchesSelector(selector);
    //             } else if(element.msMatchesSelector){
    //                 return element.msMatchesSelector(selector);
    //             } else if(element.mozMatchesSelector){
    //                 return element.mozMatchesSelector(selector);
    //             } else if(element.oMatchesSelector){
    //                 return element.oMatchesSelector(selector);
    //             }
    //         }
    //         console.log(e.target);
    //         //匹配当前组件内的所有元素
    //         let x = e.target.tabIndex;
    //         console.log('tabindex =' + x);
    //         if(x === 'divFilePage_style'){
    //             console.log('=================================');
    //             return;
    //         }
    //         self.setState({
    //             filerSearchVisible:false,
    //         })
    //     }, false);
    // }


    showFileSearch = (e)=> {
        e.nativeEvent.stopImmediatePropagation();

        this.setState({
            filerSearchVisible:!this.state.filerSearchVisible,
            articlePadVisible : false,
            moudleFrameVisible : false,
            mobanVisible: false,
        })

    };

    showArticlePad = (e) => {
        e.nativeEvent.stopImmediatePropagation();

        if (this.state.articlePadVisible === false) {
            this.article.fetchArticleData();
            this.article.fetchCategoryMenu();
        }

        this.setState({
            articlePadVisible:!this.state.articlePadVisible,
            filerSearchVisible : false,
            moudleFrameVisible : false,
            mobanVisible: false,
        })
    };

    showMoudleFrame = (e) => {
        e.nativeEvent.stopImmediatePropagation();


        this.setState({
            mobanVisible: false,
            moudleFrameVisible:!this.state.moudleFrameVisible,
            articlePadVisible:false,
            filerSearchVisible : false,
        })
    }

    showMoban = (e) => {
        e.nativeEvent.stopImmediatePropagation();
        if (this.state.mobanVisible === false) {
            this.moban.fetchMoudleData()
            this.moban.fetchMoudleMenu()
        }

        this.setState({
            mobanVisible: !this.state.mobanVisible,
            moudleFrameVisible:false,
            articlePadVisible:false,
            filerSearchVisible : false,
        })
    }

    showPreviewPage = (title,content,fileId)=> {
        this.setState({
            previewPageVisible:true,
            fileContent:content,
            fileName:title,
            fileId:fileId
        })
    };

    closePreviewPage = (e) => {
        // e.nativeEvent.stopImmediatePropagation();
        this.setState({
            previewPageVisible:false,
        })
    };

    stopMaoPao = (e) => {
        e.nativeEvent.stopImmediatePropagation();
    };

    //////show consult
    bindRef = ref => { this.child = ref };

    bindEdit = ref => (this.edit = ref);

    bineFileSearch = ref => (this.search = ref);

    bineArticle = ref => (this.article = ref);

    bindAnalyse = ref => (this.analyse = ref);

    bindMoudle = ref => (this.moudle = ref);

    bindMoban = ref => (this.moban = ref);

    handleOpenConsult = () => {
        this.dismissFileSearch();
        this.dismissArticle();
        this.child.updataFileData();
        this.setState({
            consult_visible:true,
        });
    };

    handleOpenEdit = ()=> {
        this.dismissFileSearch();
        this.isOpenFileEidt = true;
        this.edit.updataText(this.replaceContent(this.state.fileContent),this.state.fileName);
        this.setState({
           isEditPreviewContent:true,
        });
    };

    //////// edit top function area /////////////
    handleShowSetting = () => {
        this.setState({
            settingPageVisible:true,
        });
    };

    handleDismissSetting = () => {
        this.setState({
            settingPageVisible:false,
        });
    };

    saveFile = (fileName,fileConent) => {
        let formDataUpload = new FormData();
        formDataUpload.append("directory_id", 'root');
        formDataUpload.append("file_name", fileName);
        formDataUpload.append("file_id", this.state.fileId);
        formDataUpload.append("content", fileConent);
        fetchPost('saveWork',convert_FormData_to_json2(formDataUpload),null)
            .then(data => {
                if (data.code === 200) {
                    message.success('保存成功');
                    this.search.updataFile();
                }
                else {
                    showErrorMsg(data);
                }
            })
    };

    handleSaveFile = () => {
        if (this.edit.getFileName().length !== 0 && this.edit.getEditContent().length !== 0) {
            this.fileName = this.edit.getFileName();
            this.saveFile(this.fileName,this.edit.getEditContent());
        }  else if (this.edit.getFileName().length === 0) {
            message.error('请输入文章标题');
        } else if (this.edit.getEditContent().length === 0) {
            message.error('请编写文章内容');
        }
    };

    handleModalCancel = () => {
        // this.edit.updataText('','');
        this.setState({
            modalVisible:false,
        })
    };

    handleModalOK = () => {
        if (this.refs.model.value.length !== 0) {
            this.fileName = this.refs.model.value;
        }

        if (this.fileName.length !== 0) {
            let formDataUpload = new FormData();
            formDataUpload.append("directory_id", 'root');
            formDataUpload.append("file_name", this.fileName);
            formDataUpload.append("file_id", this.state.fileId);
            formDataUpload.append("content", this.edit.getEditContent());
            fetchPost('saveWork',convert_FormData_to_json2(formDataUpload),null)
                .then(data => {
                    if (data.code === 200) {
                        message.success('保存成功');
                        this.edit.updataText('','');
                        this.search.updataFile();
                        this.setState({
                           modalVisible:false,
                        });
                    }
                    else {
                        showErrorMsg(data);
                    }
                })
        }
    };

    handleNewWork = () => {
        this.fileName = this.edit.getFileName();
        if (this.edit.getEditContent().length !== 0) {
            this.setState({
                modalVisible:true,
            })
        }
    };

    getWarnningText = () => {
        return (this.fileName.length !== 0)?'需要保存当前工作吗?':'当前有未保存的工作，需要保存吗？如需保存请输入文件名';
    }

    getDisplayInput = () => {
        return (this.fileName.length !== 0)?'none':'block';
    };

    replaceContent = (content)=> {
        if (content !== null) {
            return content.replace(/\n/g,"\n\n")
        }
        return ''

    };

    //////////////////ayalyse///////////

    removeLastAyalyse = () => {
        this.analyse.recoverPageNo();
        this.setState({
            suggestionSentence:[],
        })
    }

    searchKeyWordWithSelect = (keyWord,loadMore)=> {
        this.suggestWord = keyWord;
        if (loadMore !== true) {
           this.removeLastAyalyse();
        }
        let fenciMode = this.analyse.getCurrentFenciMode();
        this.analyse.setCurrentFenci(keyWord);

        let params = {key:keyWord,mode:fenciMode,page:this.analyse.getAnalysePageNo(),size:10};
        fetchGet('sentence',params,null)
            .then(data => {
                if (data.code === 200) {
                    // if (data.data.page_data.length !== 0) {
                        var datasource = this.state.suggestionSentence;
                        let tempSource = datasource.concat(data.data.page_data);
                        if (data.data.page_data.length < 1) {
                            this.analyse.setNoMoreData();
                        }
                        this.setState({
                            suggestionSentence:tempSource
                        })
                    // }

                }
                else {
                    showErrorMsg(data);
                }
            });
    };

    setFenciToAnalyse = (fenciLocal) => {
        if (this.suggestWord !== null && this.suggestWord !== undefined && this.suggestWord.length !== 0 && this.analyse.getCurrentFenciMode() !== 'start') {
            this.searchKeyWordWithSelect(this.suggestWord,false);
        }

        this.setState({
            fenci : fenciLocal,
        });
        if (this.analyse.getCurrentFenciMode() === 'start') {
            this.handleFenciAction(fenciLocal[fenciLocal.length - 1])
        }
    };

    handleFenciAction = (fenci) => {
        this.searchKeyWordWithSelect(fenci,false)
    };

    //点击模板
    handleClickMoudleItem = (moudleItems) => {
        this.setState({
            mobanVisible:false,
        });
        console.log(moudleItems);
        this.edit.setMoudleItems(moudleItems);
    };

    loadMoreAboutAnalyse = () => {
        this.analyse.setNextPage();
        this.searchKeyWordWithSelect(this.suggestWord,true)
    };

    render() {
        return (
            <div className='divPage'>
                <div style={{display:this.state.settingPageVisible?'none':'block'}}>
                    <Editor_Pad
                                triggerRef={this.bindEdit}
                                isShowEditContent={this.state.isEditPreviewContent}
                                fileContent={this.state.fileContent}
                                isConsultVisible={this.state.consult_visible}
                                searchKeyWord={this.searchKeyWordWithSelect}
                                toAnalyseFenci={this.setFenciToAnalyse}/>

                    <Consult_App triggerRef={this.bindRef}
                                 tabTitle={this.state.fileName}
                                 fileContent={this.state.fileContent}
                                 stopMaopao={this.stopMaoPao}
                                 visible={this.state.consult_visible}/>

                    <SectionAPP suggestWord={this.suggestWord}
                                arrSententce={this.state.suggestionSentence}
                                fenci={this.state.fenci}
                                fenciAction={this.handleFenciAction}
                                triggerRef={this.bindAnalyse}
                                loadMoreAnalyse={this.loadMoreAboutAnalyse}/>
                                
                    <Detection />

                    <EditPageTop saveFile={this.handleSaveFile}
                                 newWork={this.handleNewWork}
                                 showSettingPage={this.handleShowSetting}/>

                    <FileSearch triggerRef={this.bineFileSearch}
                                stopMaoPao={this.stopMaoPao}
                                handlePreviewFile={this.showPreviewPage}
                                visible={this.state.filerSearchVisible}/>

                    <ArticleAPP visible={this.state.articlePadVisible}
                                triggerRef={this.bineArticle}
                                showPreview={this.showPreviewPage}/>

                    <MoudleFrame visible={this.state.moudleFrameVisible}
                                 triggerRef={this.bindMoudle}
                                 />
                    
                    <Moban visible={this.state.mobanVisible}
                                 triggerRef={this.bindMoban}
                                 handleClickItem={this.handleClickMoudleItem}/>

                    <EditPageLeft showFileSearch={this.showFileSearch}
                                  showArticle={this.showArticlePad}
                                  showMoudleFrame={this.showMoudleFrame}
                                  showMoban={this.showMoban}/>




                    <TextPreview
                        fileContent={this.state.fileContent}
                        openConsult={this.handleOpenConsult}
                        editContent={this.handleOpenEdit}
                        closePreviewPage={this.closePreviewPage}
                        visible={this.state.previewPageVisible}/>
                    <Modal
                        title="需要保存当前的工作吗"
                        visible={this.state.modalVisible}
                        onOk={this.handleModalOK}
                        onCancel={this.handleModalCancel}
                    >
                        {this.getWarnningText()}
                        <input ref='model' style={{width : 100 + '%',marginTop:10 + 'px',display:this.getDisplayInput()}}/>
                    </Modal>
                </div>
                <div style={{display:this.state.settingPageVisible?'block':'none',width:100 + '%',height:100 + '%'}}>
                    <Set_APP handleBack={this.handleDismissSetting} settingPageVisible={this.state.settingPageVisible}/>
                </div>
            </div>
        )
    }
}

export default EditPad;